export const MarketerPrefix = '/marketer'

export const MarketerPath = {
  MarketerHoardings: '/hoardings',
  MarketerQuotations: '/quotations',
  MarketerCampaigns: '/campaigns',
  MarketerVendors: '/vendors',
}
